import React from 'react';

import { Badge } from '@ergeon/core-components';

import { CustomerDetail } from '../../../types';

type EmailItem = {
  email: string;
  isPrimary: boolean;
};

const combineEmails = (
  primaryEmail: CustomerDetail['primary_email'],
  additionalEmails: CustomerDetail['additional_emails'],
): EmailItem[] => {
  return [
    primaryEmail && {
      email: primaryEmail.identifier,
      isPrimary: true,
    },
    ...(additionalEmails || []).map((e) => ({
      email: e.identifier,
      isPrimary: false,
    })),
  ].filter(Boolean) as EmailItem[];
};

export const renderEmailList = (
  primaryEmail: CustomerDetail['primary_email'],
  additionalEmails: CustomerDetail['additional_emails'],
) => {
  const emails = combineEmails(primaryEmail, additionalEmails);

  if (emails.length === 0) return false;

  return (
    <div className="flex flex-col gap-1">
      {emails.map((item, index) => (
        <span className="inline space-x-2" key={index}>
          <span className="break-all">{item.email}</span>
          {item.isPrimary && <Badge flavor="regular" value="Primary" />}
        </span>
      ))}
    </div>
  );
};
